import React, { useState, useRef, useCallback, useEffect, memo } from "react";
import "./styles/radio.css";

import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute } from "react-icons/fa";
import Swal from "sweetalert2";

const RadioBar = memo(({ isPlaying, isMuted, onTogglePlay, onToggleMute }) => (
  <div className="radio-bar">
    <div className="radio-content">

      <span className="radio-title">
        🎙️ Emisora virtual <strong>LaManchaAmarilla.com</strong>
      </span>

      <div className="radio-center">

        {/* PLAY / PAUSE */}
        <button className="radio-btn" onClick={onTogglePlay}>
          {isPlaying ? <FaPause /> : <FaPlay />}
        </button>

        {/* ONDAS */}
        <div className="wave-animation">
          {[...Array(10)].map((_, i) => (
            <span key={i}></span>
          ))}
        </div>

        {/* MUTE */}
        <button className="radio-btn" onClick={onToggleMute}>
          {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
        </button>

      </div>
    </div>
  </div>
));

RadioBar.displayName = "RadioBar";

// Otros reproductores (p. ej. la transmisión en vivo) disparan este evento para pausar la radio
export const PAUSE_RADIO_EVENT = "radio:pause";

export default function RadioPlayer() {

  const audioRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  // Pausar cuando otro reproductor empieza a sonar
  useEffect(() => {
    const pause = () => {
      audioRef.current?.pause();
      setIsPlaying(false);
    };
    window.addEventListener(PAUSE_RADIO_EVENT, pause);
    return () => window.removeEventListener(PAUSE_RADIO_EVENT, pause);
  }, []);

  // PLAY / PAUSE
  const togglePlay = useCallback(() => {

    if (!audioRef.current) return;

    if (isPlaying) {

      audioRef.current.pause();
      setIsPlaying(false);

    } else {

      audioRef.current.play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch((err) => {

          console.error("Error al reproducir audio:", err);

          Swal.fire({
            icon: "error",
            title: "Error de audio",
            text: "No se pudo reproducir la emisora.",
            confirmButtonColor: "#3085d6"
          });

        });
    }

  }, [isPlaying]);

  // MUTE
  const toggleMute = useCallback(() => {

    if (!audioRef.current) return;

    const newMutedState = !audioRef.current.muted;

    audioRef.current.muted = newMutedState;

    setIsMuted(newMutedState);

  }, []);

  return (
    <>
    
      {/* BARRA VISUAL */}
      <RadioBar
        isPlaying={isPlaying}
        isMuted={isMuted}
        onTogglePlay={togglePlay}
        onToggleMute={toggleMute}
      />

      {/* AUDIO */}
      <audio
        ref={audioRef}
        src="https://stream.integracionvirtual.com/proxy/lamanchaamarilla?mp=/stream"
        preload="none"

        onEnded={() => {
          setIsPlaying(false);
        }}

        onError={() => {

          setIsPlaying(false);

          Swal.fire({
            icon: "error",
            title: "Error de conexión",
            text: "No se pudo conectar a la emisora.",
            confirmButtonColor: "#3085d6"
          });

        }}
      />

    </>
  );
}